import { useState } from 'react';
import type { DragEvent } from 'react';
import { UploadCloud } from 'lucide-react';

/**
 * A `<label>` wrapping a hidden file input: clicking anywhere in the zone
 * opens the file picker via native label/input association, no ref or
 * imperative `.click()` needed. Drag-and-drop is layered on top of that.
 */
export function AttachmentDropZone({
  onFiles,
  hint,
  disabled,
}: {
  onFiles: (files: File[]) => void;
  hint: string;
  disabled?: boolean;
}) {
  const [dragging, setDragging] = useState(false);

  const handleFiles = (fileList: FileList | null) => {
    if (!fileList || fileList.length === 0) return;
    onFiles(Array.from(fileList));
  };

  return (
    <label
      className={`dropzone${dragging ? ' dragover' : ''}${disabled ? ' disabled' : ''}`}
      onDragOver={(e: DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        if (!disabled) setDragging(true);
      }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e: DragEvent<HTMLLabelElement>) => {
        e.preventDefault();
        setDragging(false);
        if (!disabled) handleFiles(e.dataTransfer.files);
      }}
    >
      <UploadCloud size={28} aria-hidden className="dropzone-icon" />
      <div className="dropzone-text">Drop files here or click to browse</div>
      <div className="dropzone-hint">{hint}</div>
      <input
        type="file"
        multiple
        disabled={disabled}
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = '';
        }}
        style={{ display: 'none' }}
      />
    </label>
  );
}
